import React, { useState, useEffect, Fragment } from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import { AvForm, AvField, AvInput } from "availity-reactstrap-validation";
import { uploadImage } from "../../apiHelpers/uploadApiHelper";
import TimeLineAPng from  "../../assets/images/a.png";
import { useDrag, useDrop } from 'react-dnd';

import { connect } from 'react-redux';
import Media from './content';


import { getMedia } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import Dropzone from "react-dropzone";

import { Tabs, Form } from 'antd';
import { AppleOutlined, AndroidOutlined } from '@ant-design/icons';
import toastr from "toastr";

const { TabPane } = Tabs;


const Content = (props) => {


    useEffect(() => {
        props.getMedia()
    }, [])

    const [layout, setLayout] = useState(1);
    const [campaignName, setCampaignName] = useState("");
    const [editModal, setEditModal] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [pending, setPending] = useState(false)


    const selectLayout = (value) => {
        setLayout(parseInt(value));
    }

    const clear = () => {
        setSelectedFiles([]);
        setEditModal(false);
        setPending(false)
    }


    const triggerAction = (value) => {
        if(value) {
            props.getMedia();
        }
    }

    const handleDragState = (value) => {
        setDragState(value)
    }

    function handleAcceptedFiles(files) {
        files.map(file =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size)
            })
        );
        files.forEach((item) => {
            setSelectedFiles((oldFiles) => [...oldFiles, item]);
        })
    };

    /**
     * Formats the size
     */
    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    const handleSave = () => {
        if (selectedFiles.length < 1) {
            toastr.info("Please select files to upload", "Info")
            return false
        }
        const formData = new FormData();
        selectedFiles.forEach((image, index) => {
            formData.append(`image[${index}]`, image);
        });
        uploadFile(formData);
    }

    const uploadFile = (data) => {
        setPending(true);
        uploadImage("/api/v1/upload_images", data)
            .then((result) => {
                setPending(false);
                if(result.status === 201) {
                    toastr.success("Image uploaded successfully", "Success");
                    props.getMedia(true);
                    clear();
                } else if(result.status === 206) {
                    toastr.warning(result.data.message, "Partially Failed");
                    props.getMedia(true);
                    clear();
                }
                else {
                    toastr.error("It seems that the files you have uploaded are already exist.", "Uploading Error");
                }
            })
            .catch((err) => {
                setPending(false);
                toastr.error("Something went wrong", "Error");
            })
    }

    const previews = () => {
        return selectedFiles.map((f, i) => {
            return (
                <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                >
                    <div className="p-2">
                        <Row className="align-items-center">
                            <Col className="col-auto">
                                {f.type.includes("image/") ? (
                                <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                />) :
                                    <video height="80">
                                        <source src={f.preview} type="video/mp4" />
                                    </video>}
                            </Col>
                            <Col>
                                <Link
                                    to="#"
                                    className="text-muted font-weight-bold"
                                >
                                    {f.name}
                                </Link>
                                <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                </p>
                            </Col>
                            <Col className="text-right">
                                <i className="fas fa-trash-alt" style={{ cursor: "pointer" }} onClick={() => handleStashImage(f.preview)}></i>
                            </Col>
                        </Row>
                    </div>
                </Card>
            );
        })
    }

    const handleStashImage = (item) => {
        let stash = selectedFiles;
        stash.splice(item, 1);
        setSelectedFiles(selectedFiles.filter(image => image !== item));
    }



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="content-parent-div">
                    <Row className="mt-3">
                        <Col sm={12}>
                            <button className="btn btn-primary btn-rounded" onClick={() => setEditModal(true)}>
                                <i className="fas fa-plus"></i> &nbsp;
                                Upload
                            </button>
                        </Col>
                        <Col sm={12} className="mt-3">
                            {!props.loading && (
                            <Tabs defaultActiveKey="1">
                                <TabPane
                                    tab={
                                        <span>
                                            All
                                        </span>
                                    }
                                    key="1"
                                >
                                    <Media contentId={1} media={props.media ? props.media : []} />
                                </TabPane>
                                <TabPane
                                    tab={
                                        <span>
                                          Images
                                        </span>
                                    }
                                    key="2"
                                >
                                    <Media contentId={2} media={props.media ? props.media : []} />
                                </TabPane>
                                <TabPane
                                    tab={
                                        <span>
                                          Videos
                                        </span>
                                    }
                                    key="3"
                                >
                                    <Media contentId={3} media={props.media ? props.media : []} />
                                </TabPane>
                            </Tabs>)}
                            {props.loading && (
                                <div className="loading-icon">
                                    <i className="fas fa-sync fa-spin"></i>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Container>

                <Modal isOpen={editModal} role="dialog" autoFocus={true} centered={true} className="myModal" tabIndex="-1" toggle={() => { clear() }}>
                    <div className="modal-content">
                        <ModalHeader toggle={() => { clear(); }}>
                           Upload Files
                        </ModalHeader >
                        <ModalBody>
                            <Fragment>
                                <Form className="mt-3">
                                    <Dropzone
                                        onDrop={acceptedFiles => { handleAcceptedFiles(acceptedFiles) }
                                        }
                                        maxSize={50000000}
                                        accept='.jpeg, .png, .jpg, .gif, .mp4, .mov, .avi, .mpg, .mkv, .ogv, .webm, .3gp'
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <div className="dropzone">
                                                <div
                                                    className="dz-message needsclick mt-2"
                                                    {...getRootProps()}
                                                >
                                                    <input {...getInputProps()} />
                                                    <div className="mb-3">
                                                        <i className="display-4 text-muted bx bxs-cloud-upload"></i>
                                                    </div>
                                                    <h4>Drop files here or click to upload.</h4>
                                                    <p style={{ fontSize: "13px" }}>Max size: 50MB, File Formats: Video or Image Files</p>
                                                </div>
                                            </div>
                                        )}
                                    </Dropzone>
                                    <div
                                        className="dropzone-previews mt-3"
                                        id="file-previews"
                                    >
                                        {previews()}
                                    </div>
                                </Form>
                            </Fragment>
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-danger" color="secondary" onClick={() => clear()}>Cancel</button>
                            <button
                                disabled={pending ? true : false}
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={handleSave}
                            >
                                {pending ? (
                                    <React.Fragment>
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                        Uploading...
                                    </React.Fragment>
                                ) : "Add Files"}
                            </button>
                        </ModalFooter>
                    </div>
                </Modal>

            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { media, loading } = state.CampaignReducer;
    return { media, loading };
}

export default withRouter(connect(mapStateToProps, { getMedia })(withNamespaces()(Content)));
